/**
 * @description: 仓库管理-采购退货
 * @author: ccy
 * @update: hwx
 * @update: lyr(2022-03-16)
 */
<template>
    <div class="procurementReturn">
        <div class="return-list" v-show="!showdetail">
            <div class="row row-margin">
                <button class="btn btn-flat btn-middle btn-orange" @click="addReturnList" v-if="hasAddPrivilege">新增采购退货单</button>
            </div>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div @click="clearDate" ref="time">
                        <input type="text" class="form-control laydate-icon" :value="startTime"> -
                        <input type="text" class="form-control laydate-icon" :value="endTime">
                    </div>
                </div>
                <label class="list-label-4">门店名称:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="selectstore" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-2">仓库:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="select_stock" data-placeholder="请选择仓库" disabled>
                    </select>
                </div>
            </div>
            <div class="row">
                <label class="list-label-3">供应商:</label>
                <div class="col-md-2">
                    <div class="input-group">
                        <input type="text" class="form-control" placeholder="请选择供应商名称" ref="selectsupplier">
                        <div class="input-group-btn">
                            <ul class="dropdown-menu dropdown-menu-right" role="menu">
                            </ul>
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-flat btn-small btn-orange pull-right" @click="queryPurchaseOut">查询</button>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="returnTable"></table>
            </div>
        </div>
        <div class="detail-panel" v-show="showdetail">
            <div class="row">
                <div class="col-md-2" v-show="visible">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" id="add-goods" @click="addGoods">添加商品</button>
                </div>
                <div class="col-md-2" v-show="visible">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" id="saleRetSave" @click="save">保存</button>
                </div>
                <div class="col-md-2">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" id="back" @click="returnIndex">返回</button>
                </div>
                <div class="col-md-2" v-show="!visible">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="getExportSet">导出</button>
                </div>
            </div>

            <div class="listTitle row">
                <div class="listBorder row"></div>
                <div class="page-title" v-show="visible">新增采购退货单</div>
                <div class="page-title" v-show="!visible">采购退货单详情</div>
                <div class="comment">
                    注释：采购退货单是指商品从门店仓库退货给供应商
                </div>
                <div class="row" style="margin-bottom: 5px">
                    <div class="col-md-11 addreturn" style="margin-left: 6%">
                        <label class="col-md-1 list-left" v-show="!visible||success">单号：</label>
                        <span class="col-md-3 list-right" v-show="!visible||success">{{OutDetailTop.number}}</span>
                        <label class="col-md-1 list-left">退货总额：</label>
                        <span class="col-md-3 list-right">{{amount}}</span>
                        <label class="col-md-1 list-left">供应商：</label>
                        <div class="col-md-3 ct-col" v-show="visible">
                            <select class="form-control" style="width: 100%;"  data-placeholder="请选择供应商" ref="outSelectSupplier">
                                <option value=""></option>
                            </select>
                        </div>
                        <span class="col-md-2 list-right" v-show="!visible" style="padding:0; line-height:32px;">{{OutDetailTop.supplier_name}}</span>
                    </div>
                </div>
                <div class="row" style="margin: 8px 0 0;">
                    <div class="col-md-11 addreturn" style="margin-left: 6%">
                        <label class="col-md-1 list-left" v-show="!visible||success">时间：</label>
                        <span class="col-md-3 list-right" v-show="!visible||success">{{OutDetailTop.create_time}}</span>
                        <label class="col-md-1 control-label">门店:</label>
                        <div class="col-md-3 ct-col">
                            <select class="form-control select2" ref="outSelectStore" data-placeholder="请选择门店" style="width: 100%;" disabled="true">
                            </select>
                        </div>
                        <label class="col-md-1 list-left">仓库:</label>
                        <div class="col-md-3 ct-col" v-show="visible">
                            <select class="form-control select2" id="detail_stock" style="width: 100%;" ref="detail_stock" data-placeholder="请选择仓库" disabled="true">
                            </select>
                        </div>
                        <span class="col-md-2 list-right" v-show="!visible" style="padding:0; line-height:32px;">{{OutDetailTop.store_name}}</span>
                    </div>
                </div>
                <div class="row" style="margin: 8px 0 0;">
                    <div class="col-md-11 addreturn" style="margin-left: 6%">
                        <label class="col-md-1">备注：</label>
                        <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="请输入备注" v-model="return_remark" ref="return_remark">
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="detaillist"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="export_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='export_allcheck' @click='exportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="goods_unit_name">
                            <label>商品单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="quantity">
                            <label>商品数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="amount">
                            <label>退货单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="amount_total">
                            <label>退货价合计</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='export_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='export_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- pop -->
            <div class="add-goods ele-hide" ref="addgoods" style="position: relative;">
                <el-radio-group v-model="pop_add_radio">
                    <el-radio :label="1">按商品</el-radio>
                    <el-radio :label="2">按商品分类</el-radio>
                </el-radio-group>
                <div class="by-goods" v-show="pop_add_radio=='1'">
                    <div class="row">
                        <div class="col-md-3 ct-col clear-pd">
                            <select class="form-control" style="width: 100%;" data-placeholder="请选择类型" ref="selectType">
                                <option value=""></option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <input type="text" class="form-control" placeholder="请输入商品名称" v-model="searchName" @keyup.13="queryGoods" />
                        </div>
                        <div class="pull-right">
                            <button type="button" class="btn btn-flat btn-small btn-orange" @click="queryGoods">查询</button>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered table-hover" data-pagination="true" ref="goodslist" ></table>
                    </div>
                    <div class="row btns">
                        <button type="button" class="btn btn-flat btn-small btn-orange pop-save" @click="saveGoods">保存</button>
                        <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="closeLayer">取消</button>
                    </div>
                </div>
                <div class="by-types" v-show="pop_add_radio=='2'">
                    <div class="checkbox-wrapper">
                        <el-checkbox v-model="checkAllGoodsType" @change="handleCheckAllChange">全选</el-checkbox>
                        <el-checkbox-group v-model="choosed_goods_type" @change="handleCheckedGoodsTypeChange">
                            <el-checkbox v-for="item in goods_type_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div class="row btns">
                        <button type="button" class="btn btn-flat btn-small btn-orange pop-save" @click="onGoodsTypeSaveClick">保存</button>
                        <button type="button" class="btn btn-flat btn-small btn-gray" @click="closeLayer">取消</button>
                    </div>
                </div>
            </div>

            <!-- 选择进货单价 -->
            <div class="purchase-price" ref="purchase_price">
                <p>商品名称：{{goodsName}}</p>
                <div class="row"></div>
                <div class="table-responsive">
                    <table class="table table-striped table-bordered table-hover" data-pagination="true" ref="purchaselist" ></table>
                </div>
                <div class="row btns">
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="closeLayer" style="margin-right: 70px">取消</button>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="purchaseChoose">确定</button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    export default {
        name: 'procurement_return',
        data () {
            return {
                msg: 'procurement_return',
                showdetail: false,
                visible:false,
                startTime: "",
                endTime: "",
                merchantList: [],
                supplierList: [],
                stockList: [],  //仓库列表
                shopId: null,
                supplierId: null,
                currentStockId: null,   //当前查询仓库id
                id: null,
                // OutDetailList: [],
                OutDetailTop: [],
                amount: 0,
                goodsTypeList: [],
                searchName: null,
                outDetailGoods: [],
                goods: false,
                goodsName: null,
                paramsdatas: null,
                success: false,
                selectdata:[],
                outSelectStore: [],
                detail_stock:"",
                hasDelPrivilege: false, // 是否有删除权限
                hasAddPrivilege: false, // 是否有新增权限
                hasEditPrivilege: false, // 是否有修改权限
                hasEditTotalPrivilege: false, // 是否有修改退货合计价权限

                export_allcheck: false,
                c_export_allcheck: false,
                export_checkModel: [],
                export_checkData: ['goods_name', 'goods_unit_name', 'goods_type_name', 'quantity', 'amount', 'amount_total'],
                export_type: 1,
                return_remark: '',
                editVisible: false,

                pop_add_radio: 1,
                goods_type_list: [],
                checkAllGoodsType: false,
                choosed_goods_type: [], // 选中的商品类型
            }
        },
        watch: {
            export_checkModel: {
                handler: function(val, oldVal) {
                    if(this.export_checkModel.length >= this.export_checkData.length) {
                        this.export_allcheck = true;
                        this.c_export_allcheck = true;
                    } else {
                        this.export_allcheck = false;
                        this.c_export_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted() {
            this.menu()
            // 日期
            var myDate = new Date();
            this.IntstartTime = myDate;
            this.IntendTime = new Date(myDate.getTime() + 1 * 24 * 3600 * 1000);
            this.IntstartTime.setHours(8, 0);
            this.IntendTime.setHours(8, 0);
            var timStar = new Date(this.IntstartTime),
                year = timStar.getFullYear(),
                month = (timStar.getMonth() + 1) < 10 ? '0' + (timStar.getMonth() + 1) : (timStar.getMonth() + 1),
                day = timStar.getDate() < 10 ? '0' + timStar.getDate() : timStar.getDate(),
                hour = timStar.getHours() < 10 ? '0' + timStar.getHours() : timStar.getHours(),
                minute = timStar.getMinutes() < 10 ? '0' + timStar.getMinutes() : timStar.getMinutes();
            var timEnd = new Date(this.IntendTime),
                yearend = timEnd.getFullYear(),
                monthend = (timEnd.getMonth() + 1) < 10 ? '0' + (timEnd.getMonth() + 1) : (timEnd.getMonth() + 1),
                dayend = timEnd.getDate() < 10 ? '0' + timEnd.getDate() : timEnd.getDate(),
                hourend = timEnd.getHours() < 10 ? '0' + timEnd.getHours() : timEnd.getHours(),
                minuteend = timEnd.getMinutes() < 10 ? '0' + timEnd.getMinutes() : timEnd.getMinutes();
            this.startTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
            this.endTime = yearend + '-' + monthend + '-' + dayend + ' ' + hourend + ':' + minuteend;
            this.innitDate();
            this.getSupplierList();

            this.initi_list_box('');
            this.getshopdata();
        },
        methods:{
            menu() {
                let _this = this,
                    menu = {};
                if(!$.isEmptyObject(this.$store.state.menunew)) {
                    menu = JSON.parse(this.$store.state.menunew);
                    $.each(menu, function(k, v) {
                        if(v.id == '543') {
                            menu = v.submenu;
                            $.each(menu, function(m, n) {
                                if(n.name == '采购退货') {
                                    menu = n.submenu;
                                    $.each(menu, function(x, y) {
                                        if (y.id == '1052') { // 新增
                                            _this.hasAddPrivilege = true;
                                        }
                                        if (y.id == '1053') { // 修改
                                            _this.hasEditPrivilege = true;
                                        }
                                        if(y.id == '1054') { // 删除
                                            _this.hasDelPrivilege = true;
                                        }
                                        if (y.id == '1055') { // 修改退货合计价
                                            _this.hasEditTotalPrivilege = true;
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            },

            actionFormatter: function(value, row, index) {
                var operStr = '<span class="text-blue detail">详情</span>'
                if (this.hasEditPrivilege) {
                    operStr += '<span class="text-blue edit">修改</span>'
                }
                if (this.hasDelPrivilege) {
                    operStr += '<span class="text-blue del">删除</span>'
                }
                return operStr
            },
            // 点击新增采购退货单
            addReturnList: function () {
                let _this = this;
                $(".addreturn").css('marginLeft','19%');
                _this.showdetail = true;
                _this.visible = true;
                _this.OutDetailTop = [];
                _this.amount = 0;
                _this.OutDetailTop.store_name = "总仓";
                _this.shopId = null;
                _this.supplierId = null;
                _this.outDetailGoods = [];
                _this.goods = false;
                _this.success = false;

                _this.initi_add_shop_name('add');

                // 门店
                $(_this.$refs.outSelectStore).val(_this.selectdata[0].id).trigger("change");
                $(_this.$refs.outSelectStore).prop("disabled", false); //可用
                $(_this.$refs.outSelectStore).on("select2:select", function (e) {
                    _this.shopId = $(this).select2("data")[0].id;
                });
                // 仓库
                _this.getstockdata(_this.selectdata[0].id, 'false');
                $(_this.$refs.detail_stock).prop("disabled", false);
                $(_this.$refs.detail_stock).select2({
                    data: [],
                    width: "190px"
                });

                _this.initAddSupplierSuggest();
                $(_this.$refs.outSelectSupplier).val("null").trigger("change");
                // 备注
                _this.return_remark = '';
                $(_this.$refs.return_remark).prop('disabled', false);

                $(_this.$refs.detaillist).bootstrapTable("destroy");
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.time).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: _this.IntstartTime,
                    endDate: _this.IntendTime
                }, function(start, end, label) {
                    _this.startTime = start.format('YYYY-MM-DD HH:mm');
                    _this.endTime = end.format('YYYY-MM-DD HH:mm');
                });
                //取消按钮
                $(_this.$refs.time).on('cancel.daterangepicker', function(ev, picker) {
                    _this.startTime = "";
                    _this.endTime = "";
                });
            },
            // 清空日期
            clearDate: function() {
                this.startTime = "";
                this.endTime = "";
            },
            // 初始化采购退货表格
            innitPurchaseOutDetail: function(pageNumber) {
                const _this = this;
                _this.goods = true;
                let actionEvents = {
                    'click .editableicon': function(e, value, row, index) {
                        $(this).prev().addClass("editableinput-focus");
                        $(this).prev().attr("contenteditable", true);
                        $(this).addClass("editiconend");
                        $(this).prev().focus();
                    },
                    'keypress .editableinput': function(e, value, row, index) {
                        if(event.keyCode == "13") {
                            $(this).blur();
                        }
                    },
                    'blur .editableinput': function(e, value, row, index) {
                        $(this).removeClass("editableinput-focus");
                        $(this).attr("contenteditable", false);
                        $(this).next().removeClass("editiconend");
                        if(isNaN($(this).text())) {
                            layer.msg("请输入数字");
                            $(this).text(value);
                            return;
                        } else if($(this).text() < 0) { // 数量不小于0
                            layer.msg("数量不小于0");
                            $(this).text(value);
                            return;
                        }
                        for(let i = 0; i < _this.outDetailGoods.length; i++) {
                            if(row.merchant_goods_id == _this.outDetailGoods[i].merchant_goods_id) {
                                // 数量编辑
                                _this.outDetailGoods[i].quantity = $(this).text();
                                if (!_this.outDetailGoods[i].have_edit_amount_total) {
                                    _this.outDetailGoods[i].amount_total = new Big(_this.outDetailGoods[i].amount).times($(this).text());
                                }
                                if(!_this.visible) {
                                    _this.editReturnGood(row.id, $(this).text(), _this.outDetailGoods[i].amount, _this.outDetailGoods[i].amount_total);
                                }
                            }
                        }
                        // $(_this.$refs.detaillist).bootstrapTable('refresh');
                        _this.keepScroll();
                        _this.outPriceCount();
                    }
                };
                $(_this.$refs.detaillist).bootstrapTable("destroy");
                $(_this.$refs.detaillist).bootstrapTable({
                    pageNumber: pageNumber || 1,
                    pageSize: 5,
                    pageList: [],
                    pagination: true,
                    columns: [{
                        field: "merchant_goods_id",
                        title: "商品id",
                        visible: false
                    }, {
                        field: "goods_name",
                        title: "商品名称",
                        width: "15%"
                    }, {
                        field: "goods_unit_name",
                        title: "商品单位",
                        width: "8%"
                    }, {
                        field: "goods_type_name",
                        title: "商品类型",
                        width: "10%"
                    }, {
                        field: "quantity",
                        title: "商品数量",
                        width: "13%",
                        events: actionEvents,
                        formatter: _this.quantityFormatter
                    }, {
                        field: "amount",
                        title: "进货单价",
                        width: "10%",
                        events: {
                            'click .getamount': function(e, value, row) {
                                _this.shopId = $(_this.$refs.outSelectStore).val() || null;
                                _this.supplierId = $(_this.$refs.outSelectSupplier).val() || null;
                                if(_this.supplierId == null) {
                                    layer.msg("请选择供应商",{
                                        time: 1200
                                    });
                                } else if(_this.shopId == null) {
                                    layer.msg("请选择门店", {
                                        time: 1200
                                    });
                                } else {
                                    _this.goodsName = row.goods_name;
                                    _this.merchant_goods_id = row.merchant_goods_id;
                                    _this.initPurchaseTable();
                                    layer.open({
                                        type: 1,
                                        title: '选择进货单价',
                                        skin: 'layui-layer-rim', // 加上边框
                                        area: ['700px', ''],
                                        content: $(_this.$refs.purchase_price)
                                    });
                                }
                            }
                        },
                        formatter: function(value, row, index) {
                            if(!_this.visible && !_this.editVisible) {
                                return row.amount;
                            } else if(row.amount != '') {
                                return '<div class="orange-text"><a class="getamount">'+ row.amount +'</a></div>';
                            } else {
                                if(row.isshow == true) {
                                    return '<div class="orange-text"><a class="getamount">'+ row.amount +'</a></div>';
                                } else {
                                    return '<div class="orange-text getpurchase">' +
                                    '<a class="getamount">点击获取进货价</a>' +
                                    '</div>'
                                }
                            }
                        }
                    }, {
                        field: "amount_total",
                        title: "退货价合计",
                        width: "10%",
                        events: {
                            'click .editableicon': function(e, value, row, index) {
                                $(this).prev().addClass("editableinput-focus");
                                $(this).prev().attr("contenteditable", true);
                                $(this).addClass("editiconend");
                                $(this).prev().focus();
                            },
                            'keypress .editableinput': function(e, value, row, index) {
                                if(event.keyCode == "13") {
                                    $(this).blur();
                                }
                            },
                            'blur .amount_total': function(e, value, row) {
                                $(this).removeClass("editableinput-focus");
                                $(this).attr("contenteditable", false);
                                $(this).next().removeClass("editableiconend");
                                if($(this).text() - 0 < 0) {
                                    layer.msg("价格不小于0");
                                    $(this).text(value);
                                }
                                if($(this).text().split('.')[1] && $(this).text().split('.')[1].length > '6') {
                                    $(this).text(new Big($(this).text()).toFixed(6));
                                }
                                for(let i = 0; i < _this.outDetailGoods.length; i++) {
                                    if(row.merchant_goods_id == _this.outDetailGoods[i].merchant_goods_id) {
                                        _this.outDetailGoods[i].amount_total = $(this).text()
                                        _this.outDetailGoods[i].have_edit_amount_total = true // 手动修改过退货价合计
                                        if(!_this.visible) {
                                            _this.editReturnGood(row.id, _this.outDetailGoods[i].quantity, _this.outDetailGoods[i].amount, $(this).text());
                                        }
                                    }
                                }
                                _this.outPriceCount();
                            }
                        },
						formatter: function(value, row, index) {
							if(!_this.visible && !_this.editVisible) {
                                return value;
                            } else {
                                if (_this.hasEditTotalPrivilege) {
                                    return [
                                        '<div class="editableinput amount_total" contenteditable="false">' + value + '</div>' +
                                        '<a class="editableicon"></a>'
                                    ].join('');
                                }else {
                                    return '<div class="editableinput amount_total" contenteditable="false">' + value + '</div>'
                                }
                            }
						}
                    }, {
                        field: "op",
                        title: "操作",
                        width: "10%",
                        events: {
                            'click .delete': function (e, value, row) {
                                layer.confirm('确认删除' + row.goods_name + '吗？', {
                                    btn: ['确定', '取消'] //按钮
                                }, function() {
                                    if(!_this.visible) {
                                        _this.delDetReturn(row.id);
                                    }
                                    for(let i = 0; i < _this.outDetailGoods.length; i++ ) {
                                        if(row.merchant_goods_id == _this.outDetailGoods[i].merchant_goods_id) {
                                            _this.outDetailGoods.splice(i, 1);

                                            // 刷新滚动条不变
                                            let scollPostion = $('.tab-content').scrollTop();
                                            _this.innitPurchaseOutDetail($(_this.$refs.detaillist).bootstrapTable('getOptions').pageNumber);
                                            $('.tab-content').scrollTop(scollPostion);

                                            _this.outPriceCount();
                                            break;
                                        }
                                    }
                                    layer.closeAll();
                                });
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<div class="orange-text">' +
                                '<a class="delete">删除</a>' +
                                '</div>'
                        }
                    }],
                    // data: (_this.visible == false) ? _this.OutDetailList : _this.outDetailGoods
                    data: _this.outDetailGoods
                })
            },
            quantityFormatter: function(value, row, index) {
                let _this = this;
                if(!_this.visible) {
                    return row.quantity;
                } else {
                    return [
                        '<div class="editableinput" contenteditable = "false" >' + row.quantity + '</div>' +
                        '<a class="editableicon"></a>'
                    ].join('');
                }
            },
            // 获取采购退货单详情
            getPurchaseOutDetail: function(id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": []
                };
                let datas2 = JSON.stringify(datas);
                layer.load(0, {
                    shade: [0.1, '#ececec'] // 0.1透明度的白色背景
                });
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/getPurchaseOutDetail",
                    data: datas2,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        layer.closeAll();
                        if(data.response.result_code == "true") {
                            $(_this.$refs.detaillist).bootstrapTable('destroy');
                            _this.OutDetailTop = data.response.result.data;
                            _this.visible = false;
                            _this.outDetailGoods = data.response.result.data.goods;
                            _this.innitPurchaseOutDetail();
                            if(!_this.editVisible) {
                                $(_this.$refs.detaillist).bootstrapTable('hideColumn', 'op'); // 隐藏操作列
                            }
                            // 退货总额
                            _this.amount = data.response.result.data.amount;
                            // 门店
                            let p_shop_id = data.response.result.data.shop_id - 0;
                            $(_this.$refs.outSelectStore).val(p_shop_id).trigger("change");
                            // 仓库
                            let p_store_id = data.response.result.data.store_id - 0;
                            $(_this.$refs.detail_stock).val(p_store_id).trigger("change");
                            // 供应商
                            $(_this.$refs.outSelectSupplier).select2("val", [data.response.result.data.supplier_id - 0]);
                            // 备注
                            _this.return_remark = data.response.result.data.remark;
                            $(_this.$refs.return_remark).prop('disabled', true);
                            _this.showdetail = true;
                            // $(".editableicon").hide();
                            $(".addreturn").css('marginLeft','6%');
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                        }
                    },
                    error: function(err) {
                        layer.closeAll();
                        layer.msg("网络错误");
                    }
                });
            },
            // 点击“新增商品”
            addGoods: function() {
                let _this = this;
                _this.shopId = $(_this.$refs.outSelectStore).val() || null;
                _this.supplierId = $(_this.$refs.outSelectSupplier).val() || null;
                if(_this.supplierId == null) {
                    layer.msg("请选择供应商",{
                        time: 1200
                    });
                    return;
                }
                if(_this.shopId == null) {
                    layer.msg("请选择门店",{
                        time: 1200
                    });
                    return;
                }
                _this.searchName = '';
                _this.pop_add_radio = 1
                _this.checkAllGoodsType = false
                _this.choosed_goods_type = [] // 选中的商品类型
                layer.open({
                    type: 1,
                    title: '添加退货商品',
                    skin: 'layui-layer-rim', //加上边框
                    area: ['820px', '600px'],
                    content: $(_this.$refs.addgoods)
                });
                _this.getGoodsType();
                _this.initGoodsTable(_this.shopId);
            },
            // 初始化商品列表
            initGoodsTable: function(shop_id) {
                let _this = this;
                $(_this.$refs.goodslist).bootstrapTable('destroy');
                $(_this.$refs.goodslist).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 5,
                    pageList: [5,10,20,30,50,100],
                    pagination: true,
                    height: 350,
                    ajax: function(params) {
                        _this.getGoods(params, shop_id);
                    },
                    sidePagination: "server",
                    columns: [{
                        checkbox: true,
                        title: "全选"
                    }, {
                        field: "merchant_goods_id",
                        title: "商品id",
                        visible: false
                    }, {
                        field: "goods_type_name",
                        title: "类型"
                    }, {
                        field: "goods_name",
                        title: "名称"
                    }, {
                        field: "goods_unit_name",
                        title: "单位"
                    }],
                    clickToSelect: true
                });
            },
            closeLayer: function() {
                layer.closeAll();
                this.clearPop();
            },
            // 清空弹窗的值
            clearPop: function() {
                $(this.$refs.selectType).val("null").trigger('change');
                // $(this.$refs.goodname).val("");
                $(this.$refs.goodslist).bootstrapTable("destroy");
            },
            //点击新增退货商品弹窗的“查询”按钮
            queryGoods: function() {
                // $(this.$refs.goodslist).bootstrapTable("destroy");
                this.initGoodsTable($(this.$refs.outSelectStore).val());
            },
            initi_list_box: function(boxdatas) {
                $(this.$refs.select_stock).html("");
                $(this.$refs.select_stock).select2({
                    data: boxdatas,
                    minimumResultsForSearch: -1,
                    language: "zh-CN",
                    width: '100%'
                });
            },
            // 门店数据
            getshopdata: function() {
                let _this = this;

                let shopDatas = [];
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    shopDatas.push({ id: v.id, text: v.name });
                                }
                            });
                            $(_this.$refs.selectstore).select2({
                                data: shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function(e) {
                                _this.shopId = e.params.data.id;
                                if(e.params.data.text == "全部") {
                                    _this.initi_list_box('');
                                    $(_this.$refs.select_stock).prop("disabled", true);
                                    return;
                                }
                                $(_this.$refs.select_stock).prop("disabled", false);
                                _this.getstockdata(e.params.data.id);
                            });
                            $(_this.$refs.selectstore).val(data.response.result[1].id).trigger('change');
                            _this.shopId = data.response.result[1].id;
                            $(_this.$refs.select_stock).prop("disabled", false);
                            _this.getstockdata(_this.shopId);
                            _this.initPurchaseOutTable();

                            _this.selectdata = shopDatas;
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                    }
                });
            },
            // 仓库数据
            getstockdata: function(shop_id, type, cur_id, info, rowid) {
                var _this = this;
                var boxdatas = [{ id:" ", text: "全部" }];
                var datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getStoreList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            if(info == 'detail') {
                                _this.getPurchaseOutDetail(rowid);
                            }
                            if(type == "false") {
                                _this.shop_stockdata = [];
                                $.each(data['response']['result'], function(k, v) {
                                    _this.shop_stockdata.push({ id: v.id, text: v.name });
                                });
                                $(_this.$refs.detail_stock).html("");
                                $(_this.$refs.detail_stock).select2({
                                    data: _this.shop_stockdata,
                                    minimumResultsForSearch: -1,
                                    language: "zh-CN"
                                }).select2("val", [cur_id]);
                                
                                return;
                            }
                            $.each(data['response']['result'], function(k, v) {
                                boxdatas.push({ id: v.id, text: v.name });
                            });
                            _this.initi_list_box(boxdatas);
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                    }
                });
            },
            // 门店2
            initi_add_shop_name: function(info, shop_id, store_id, rowid) {
                var _this = this;
                var selectdata = this.selectdata;
                // selectdata.splice(0, 1);
                // selectdata.unshift({ id:"", text: ""});
                $(_this.$refs.outSelectStore).html("");
                if(info == 'detail') {
                    $(_this.$refs.outSelectStore).select2({
                        data: selectdata,
                        allowClear: true,
                        minimumResultsForSearch: -1,
                        language: "zh-CN"
                    }).on("select2:select",function(e){
                        
                    });
                    _this.getstockdata(shop_id, 'false', store_id, info, rowid);
                    $(_this.$refs.outSelectStore).prop("disabled", true);
                    $(_this.$refs.detail_stock).prop("disabled", true);
                } else if(info == 'add') {
                    $(_this.$refs.outSelectStore).select2({
                        data: selectdata,
                        allowClear: true,
                        minimumResultsForSearch: -1,
                        language: "zh-CN"
                    }).on("select2:select",function(e){
                        $(_this.$refs.detail_stock).prop("disabled", false);
                        _this.getstockdata(e.params.data.id, 'false');
                    });
                }
            },

            // 请求供应商
            getSupplierList: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getSupplier",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let result = data.response.result.data.rows;
                            let item = {
                                id:"0",
                                name:"全部"
                            };
                            result.unshift(item);
                            _this.supplierList = result;
                            // if(_this.visible == false) {
                            _this.initSupplierSuggest();
                            // } else {
                            _this.initAddSupplierSuggest();
                            // }
                        } else {
                             Vue.timeoutfun(data.response.result_status,_this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 初始化供应商
            initSupplierSuggest: function() {
                let _this = this;
                $(_this.$refs.selectsupplier).bsSuggest({
                    data: {
                        value: _this.supplierList
                    },
                    ignorecase: true,
                    showHeader: false,
                    showBtn: false,
                    delayUntilKeyup: true,
                    effectiveFields: ["name"],
                    idField: "id",
                    keyField: "name"
                }).on('onSetSelectValue', function(e, keyword, data) {
                    _this.supplierId = data.id;
                });
            },
            // 新增采购退货单--初始化供应商
            initAddSupplierSuggest:function () {
                let _this = this;
                let list = _this.supplierList;
                list.shift();
                let supplier = [];
                $.each(list, function(k, v) {
                    supplier.push({ id: v.id, text: v.name });
                });
                $(_this.$refs.outSelectSupplier).select2({
                    data: supplier,
                    language: "zh-CN"
                });
            },
            // 获取采购退货单列表
            searchPurchaseOutList: function(params) {
                let _this = this;
                let pageNumber = 1;
                if(params.data.offset != 0) {
                    pageNumber = parseFloat(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": 10,
                            "shop_id": _this.shopId, // 门店id
                            "supplier_id": _this.supplierId, // 供应商id
                            "store_id": $.trim($(_this.$refs.select_stock).val()),
                            "start_time": _this.startTime, // 开始时间(时间戳)
                            "end_time": _this.endTime // 结束时间(时间戳)
                        }
                    },
                    "comment": []
                };
                let datas2 = JSON.stringify(datas);

                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/searchPurchaseOutList",
                    data: datas2,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.data.total,
                                rows: data.response.result.data.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            params.success({
                                total: 0,
                                rows: []
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 相差几小时
            getReturnHours: function(start, end) {
                var ms = end.getTime() - start.getTime();
                if(ms < 0) return 0;
                return Math.floor(ms/1000/60/60);
            },
            // 初始化采购退货单表格
            initPurchaseOutTable: function() {
                let _this = this;
                let actionEvents = {
                    'click .detail': function(e, value, row, index) {
                        _this.editVisible = false;
                        _this.initi_add_shop_name('detail', row.shop_id, row.store_id, row.id);
                    },
                    'click .edit': function(e, value, row) {
                        if(_this.getReturnHours(new Date(row.create_time), new Date()) >= '48') {
                            layer.msg('退货单已超过48小时，无法修改');
                        } else {
                            _this.editVisible = true;
                            _this.initi_add_shop_name('detail', row.shop_id, row.store_id, row.id);
                        }
                    },
                    'click .del': function(e, value, row) {
                        if(_this.getReturnHours(new Date(row.create_time), new Date()) >= '48') {
                            layer.msg('退货单已超过48小时，无法删除');
                        } else {
                            layer.confirm('删除后不可恢复，确定删除吗？', {
                                btn: ['确定', '取消']
                            }, function() {
                                _this.delReturn(row.id);
                            });
                        }
                    }
                };
                $(this.$refs.returnTable).bootstrapTable('destroy');
                $(this.$refs.returnTable).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    ajax:function(params){
                        _this.paramsdatas = params;
                        _this.searchPurchaseOutList(params);
                    },
                    sidePagination: "server",
                    pagination: true,
                    columns: [{
                        field: "number",
                        title: "退购单号",
                        width: "15%"
                    }, {
                        field: "create_time",
                        title: "退购日期",
                        width: "10%"
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "10%"
                    }, {
                        field: "store_name",
                        title: "仓库",
                        width: "10%"
                    }, {
                        field: "supplier_name",
                        title: "供应商",
                        width: "10%"
                    }, {
                        field: "quantity",
                        title: "退购数量",
                        width: "8%"
                    }, {
                        field: "amount",
                        title: "退购总额",
                        width: "10%"
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: "10%"
                    }, {
                        title: "操作",
                        width: "13%",
                        events: actionEvents,
                        formatter: _this.actionFormatter
                    }]
                })
            },
            // 点击查询采购退货单
            queryPurchaseOut: function() {
                let _this = this;
                
                if(($(_this.$refs.selectsupplier).val() == null) || ($(_this.$refs.selectsupplier).val() == '')) {
                    _this.supplierId = null;
                }
                if(($(_this.$refs.select_stock).val() == null) || ($(_this.$refs.select_stock).val() == '')) {
                    _this.currentStockId = null;
                }
                this.initPurchaseOutTable();
            },
            // 删除退货单
            delReturn: function(id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/delPurchaseOut",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        layer.closeAll();
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.returnTable).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.closeAll();
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取商品类型
            getGoodsType: function(params) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                    },
                    "comment": []
                };
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.goodsTypeList.push({
                                id: "0",
                                text: "全部"
                            });
                            $.each(data.response.result.data, function(k, v) {
                                _this.goodsTypeList.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.selectType).select2({
                                data: _this.goodsTypeList,
                                allowClear: true,
                                language: "zh-CN"
                            });
                            _this.goods_type_list = data.response.result.data
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 获取商品
            getGoods: function(params, shop_id) {
                let _this = this;
                let pageNumber = 1;
                if (params.data.offset != 0) {
                    pageNumber = parseFloat(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "goods_type": $(_this.$refs.selectType).val() || "",
                            "goods_name": _this.searchName || "",
                            "shop_id": shop_id,
                            "store_id": $(_this.$refs.detail_stock).val(),
                            "supplier_id": _this.supplierId,
                            "api_type": 'purchaseOut'
                        }
                    },
                    "comment": []
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/getPurchaseInGoods",
                    data: datas2,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let result = data.response.result.data.rows;
                            params.success({
                                total: data.response.result.data.total,
                                rows: data.response.result.data.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            params.success({
                                total: 0,
                                rows: []
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 添加商品点击保存
            saveGoods: function() {
                let _this = this;
                $.map($(_this.$refs.goodslist).bootstrapTable('getSelections'), function(row) {
                    for(let i = 0; i < _this.outDetailGoods.length; i++) {
                        if(_this.outDetailGoods[i].merchant_goods_id == row.merchant_goods_id) {
                            layer.msg('商品已存在');
                            return;
                        }
                    }
                    _this.outDetailGoods.push({merchant_goods_id: row.merchant_goods_id, quantity: 1, goods_name: row.goods_name, goods_type_name: row.goods_type_name,
                        goods_unit_name: row.goods_unit_name, purchase_id: '', purchase_number: '', amount: row.purchase_amount, amount_total: row.purchase_amount, isshow: false, contract_amount: row.contract_amount});
                    
                    _this.outPriceCount();

                    layer.msg("成功添加商品");
                    if(_this.outDetailGoods.length > 0) {
                        $(_this.$refs.outSelectSupplier).on("select2:select", function(e) {
                            if(_this.outDetailGoods.length > 0) {
                                layer.confirm('修改供应商，上次添加商品数据将不保存，确定修改？', {
                                    btn: ['确定', '取消'], // 按钮
                                    title: ['提示', true]
                                }, function() {
                                    _this.outDetailGoods = [];
                                    _this.innitPurchaseOutDetail();
                                    layer.closeAll();
                                }, function() {
                                    $(_this.$refs.outSelectSupplier).val(_this.supplierId).trigger("change");
                                    layer.closeAll();
                                });
                            }
                        });
                        $(_this.$refs.outSelectStore).on("select2:select", function (e) {
                            if(_this.outDetailGoods.length > 0) {
                                layer.confirm('修改门店，上次添加商品数据将不保存，确定修改？', {
                                    btn: ['确定', '取消'], //按钮
                                    title: ['提示', true]
                                }, function() {
                                    _this.outDetailGoods = [];
                                    _this.innitPurchaseOutDetail();
                                    layer.closeAll();
                                }, function() {
                                    $(_this.$refs.outSelectStore).val(_this.shopId).trigger("change");
                                    layer.closeAll();
                                });
                            }
                        });
                    }
                });
                _this.goods = true;
                _this.innitPurchaseOutDetail();
            },

            // 点击“全选”商品类型
            handleCheckAllChange(val) {
                this.choosed_goods_type = []
                if (!!val) {
                    this.goods_type_list.forEach(item => {
                        this.choosed_goods_type.push(item.id)
                    })
                }
            },
            // 选择商品类型
            handleCheckedGoodsTypeChange(value) {
                let checkedCount = value.length;
                this.checkAllGoodsType = checkedCount === this.goods_type_list.length;
            },
            // 商品类型选择“保存”
            onGoodsTypeSaveClick() {
                if (this.choosed_goods_type.length < 1) {
                    layer.msg("请先选择商品类型！")
                    return
                }
                this.getGoodsByTypeArr(this.choosed_goods_type)
            },
            // 根据商品类型数组获取全部商品
            getGoodsByTypeArr(type_arr) {
                let _this = this
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": 0,
                            "page_size": 0,
                            "goods_type": '',
                            "goods_name": '',
                            "goods_type_arr": type_arr,
                            "shop_id": _this.shopId,
                            "store_id": $(_this.$refs.detail_stock).val(),
                            "supplier_id": _this.supplierId,
                            "api_type": 'purchaseOut'
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);

                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/getPurchaseInGoods",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let res = data.response.result.data.rows
                            $.map(res, function(row) {
                                for(let i = 0; i < _this.outDetailGoods.length; i++) {
                                    if(_this.outDetailGoods[i].merchant_goods_id == row.merchant_goods_id) {
                                        layer.msg('商品已存在');
                                        return;
                                    }
                                }
                                _this.outDetailGoods.push({merchant_goods_id: row.merchant_goods_id, quantity: 1, goods_name: row.goods_name, goods_type_name: row.goods_type_name,
                                    goods_unit_name: row.goods_unit_name, purchase_id: '', purchase_number: '', amount: row.purchase_amount, amount_total: row.purchase_amount, isshow: false, contract_amount: row.contract_amount});
                                
                                _this.outPriceCount();

                                layer.msg("成功添加商品");
                            })
                            _this.innitPurchaseOutDetail();
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 添加采购退货单点击保存
            save: function() {
                let _this = this;
                _this.shopId = $(_this.$refs.outSelectStore).val() || null;
                _this.supplierId = $(_this.$refs.outSelectSupplier).val() || null;
                if(_this.supplierId == null) {
                    layer.msg("请选择供应商",{
                        time: 1200
                    });
                } else if(_this.shopId == null) {
                    layer.msg("请选择门店",{
                        time: 1200
                    });
                } else if(_this.outDetailGoods.length == 0) {
                    layer.msg("请添加商品",{
                        time: 1200
                    });
                } else {
                    let list = [];
                    for( let i = 0; i < _this.outDetailGoods.length; i++) {
                        if(_this.outDetailGoods[i].amount == '' && _this.outDetailGoods[i].isshow == false) {
                            layer.msg("请先设置商品进货价",{
                                time: 1200
                            });
                            return;
                        } else {
                            let item = {};
                            item = {
                                "purchase_id":  _this.outDetailGoods[i].purchase_id, // 采购单id
                                "purchase_number":  _this.outDetailGoods[i].purchase_number, // 采购单号
                                "merchant_goods_id": _this.outDetailGoods[i].merchant_goods_id,
                                "quantity": Number(_this.outDetailGoods[i].quantity),
                                "amount": _this.outDetailGoods[i].amount,
                                "amount_total": _this.outDetailGoods[i].amount_total,
                                "contract_amount": _this.outDetailGoods[i].contract_amount
                            };
                            list.push(item);
                        }
                    }
                    let datas = {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "shop_id": _this.shopId,
                                "supplier_id": _this.supplierId, // 供应商id
                                "amount": _this.amount, // 退货总额
                                "store_id": $(_this.$refs.detail_stock).val(),
                                "remark": _this.return_remark,
                                "goods": list
                            },
                            "comment": []
                        }
                    };
                    let datas2 = JSON.stringify(datas);
                    $.ajax({
                        type: "post",
                        dataType: "json",
                        url: Vue.ctUrl + "stock/addPurchaseOut",
                        data: datas2,
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: true
                        },
                        success: function(data) {
                            if(data.response.result_code == "true") {
                                $('#saleRetSave').prop('disabled', true);
                                layer.msg("添加成功！",{
                                    time: 2000
                                });
                                $(".addreturn").css('marginLeft', '6%');
                                _this.success = true;
                                _this.OutDetailTop.number = data.response.result.data.number;
                                _this.OutDetailTop.create_time = data.response.result.data.create_time;
                                setTimeout(function() {
                                    _this.showdetail = false;
                                    _this.shopId = null;
                                    _this.supplierId = null;
                                    _this.initPurchaseOutTable();
                                    $(_this.$refs.selectstore).val('').trigger('change');
                                    $('#saleRetSave').prop('disabled', false);
                                }, 2000);
                            } else {
                                Vue.timeoutfun(data.response.result_status,_this);
                                layer.msg(data.response.error_msg,{
                                    time: 1200
                                });
                            }
                        },
                        error: function(err) {
                            layer.msg("网络错误");
                        }
                    });
                }
            },
            // 初始化进货价列表
            initPurchaseTable: function() {
                let _this = this;
                $(this.$refs.purchaselist).bootstrapTable('destroy');
                $(_this.$refs.purchaselist).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 4,
                    pageList: [],
                    ajax:function(params){
                        _this.paramsdatas = params;
                        _this.getPurchasePrice(params);
                    },
                    pagination: true,
                    sidePagination: "server",
                    singleSelect: true,
                    columns: [{
                        checkbox: true,
                        title: "选中",
                        width: "10%"
                    }, {
                        field: "create_time",
                        title: "进货日期",
                        width: "35%"
                    }, {
                        field: "number",
                        title: "采购进货单号",
                        width: "30%"
                    }, {
                        field: "amount",
                        title: "进货单价",
                        width: "25%"
                    }],
                });

            },
            // 获取进货价列表
            getPurchasePrice: function(params) {
                let _this = this;
                let pageNumber = 1;
                if (params.data.offset != 0) {
                    pageNumber = parseFloat(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": 4,
                            "shop_id": _this.shopId,
                            "supplier_id": _this.supplierId,
                            "merchant_goods_id": _this.merchant_goods_id
                        }
                    },
                    "comment": []
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/getPurchaseInPriceList",
                    data: datas2,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let result = data.response.result.data.rows;
                            params.success({
                                total: data.response.result.data.total,
                                rows: data.response.result.data.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            params.success({
                                total: 0,
                                rows: []
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 选择进货价
            purchaseChoose: function() {
                let _this = this;
                $.map($(_this.$refs.purchaselist).bootstrapTable('getSelections'), function(row) {
                    for( let i = 0; i < _this.outDetailGoods.length; i++ ) {
                        if(_this.merchant_goods_id == _this.outDetailGoods[i].merchant_goods_id) {
                            _this.outDetailGoods[i].amount = row.amount;
                            if (!_this.outDetailGoods[i].have_edit_amount_total) {
                                _this.outDetailGoods[i].amount_total = new Big(row.amount).times(_this.outDetailGoods[i].quantity);
                            }
                            _this.outDetailGoods[i].purchase_id = row.purchase_id;
                            _this.outDetailGoods[i].purchase_number = row.number;
                            _this.outDetailGoods[i].isshow = true;
                            if(!_this.visible) {
                                _this.editReturnGood(_this.outDetailGoods[i].id, _this.outDetailGoods[i].quantity, row.amount, _this.outDetailGoods[i].amount_total);
                            }
                            _this.keepScroll();
                            _this.outPriceCount();
                        }
                    }
                });
                layer.closeAll();
            },
            // 计算退货总额
            outPriceCount: function() {
                let _this = this;
                _this.amount = 0;
                for( let i = 0; i < _this.outDetailGoods.length; i++) {
                    if(_this.outDetailGoods[i].amount != '') {
                        _this.amount = new Big(_this.outDetailGoods[i].amount_total).plus(_this.amount);
                    }
                }
                _this.amount = _this.amount;
            },
            // 刷新滚动条不变
            keepScroll: function() {
                let scollPostion = $('.el-tabs__content').scrollTop();
                console.log("scollPostion", scollPostion)
                $(this.$refs.detaillist).bootstrapTable('refreshOptions', {});
                $('.el-tabs__content').scrollTop(scollPostion);
            },
            // 修改商品数量、商品单价
            editReturnGood: function(id, quantity, amount, amount_total) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "quantity": quantity,
                            "amount": amount,
                            "amount_total": amount_total
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/modifyPurchaseOutDetail",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 删除详情页商品
            delDetReturn: function(id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/delPurchaseOutDetail",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 返回
            returnIndex: function () {
                let _this = this;
                _this.showdetail = false;
                _this.shopId = null;
                _this.supplierId = null;
                $(_this.$refs.selectstore).val('').trigger('change');;
                $(_this.$refs.selectsupplier).val('');
                $(_this.$refs.detail_stock).html("");
                _this.initPurchaseOutTable();
            },
            // 获取导出设置
            getExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "stock/purchaseOutExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.export_checkModel = data.response.result.export_fields;
                                _this.export_type = data.response.result.export_type;
                            } else {
                                _this.export_checkModel = _this.export_checkData;
                                _this.export_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.export_alert)
                }, function() {
                    _this.exportDetail();
                });
            },
            // 导出字段全选
            exportCheckedAll: function() {
                let _this = this;
                _this.export_allcheck = _this.c_export_allcheck;
                if(!_this.export_allcheck) { // 实现全选
                    _this.export_checkModel = [];
                    _this.export_checkData.forEach(function(item) {
                        _this.export_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.export_checkModel = [];
                }
            },
            // 导出
            exportDetail: function() {
                let export_fields = JSON.stringify(this.export_checkModel);
                window.location.href = Vue.ctUrl + "stock/purchaseOutExport?" +
                    "id=" + this.OutDetailTop.id +
                    "&export_fields=" + export_fields +
                    "&export_type=" + this.export_type;
                layer.msg("导出成功！");
                layer.closeAll();
            }
        }
    }
</script>

<style lang="less" >
    .procurementReturn {
        .detail-panel {
            .col-md-1,
            .col-md-3 {
                padding-left: 0;
            }
            .col-md-1 {
                height: 32px;
                line-height: 32px;
            }
            .listTitle {
                margin-top: 30px;
                height: 255px;
                position: relative;
                background-color: rgb(243,243,243);
                font-size: 14px;
                color: #535353;
                .listBorder {
                    width: 100%;
                    height: 10px;
                    position: absolute;
                    top: 0;
                    background-color: rgb(215,215,215);
                }
                .list-right {
                    text-align: left;
                }
                .list-left {
                    text-align: left;
                }
                .col-md-1 {
                    padding-left: 0;
                    padding-right: 0;
                    height: 32px;
                    line-height: 32px;
                }
                .col-md-3 {
                    padding-left: 0;
                    height: 32px;
                    line-height: 32px;
                }
                .page-title {
                    height: 30px;
                    line-height: 30px;
                    font-size: 20px;
                    text-align: center;
                    margin-top: 20px;
                }
                .comment {
                    height: 30px;
                    margin-bottom: 20px;
                    line-height: 30px;
                    font-size: 12px;
                    color: #009af0;
                    text-align: center;
                }
            }

            .add-goods {
                width: 100%;
                height: 100%;
                padding: 20px 30px;
                display: none;
                .btns {
                    margin-top: 10px;
                    /*position: absolute;*/
                    bottom: 30px;
                    .pop-save {
                        margin: 0 50px 0 200px;
                    }
                }
            }
        }
        .purchase-price {
            display: none;
            padding: 20px 50px;
            p {
                font-size: 14px;
            }
            .btns {
                text-align: center;
            }
        }
        .set-export {
            padding: 0 20px 20px;
            h3 {
                font-size: 16px;
            }
            li {
                float: left;
                width: 20%;
            }
        }
        .add-goods {
            .el-radio-group {
                margin-bottom: 15px;
            }
            .checkbox-wrapper {
                max-height: 350px;
                overflow-y: auto
            }
            .el-checkbox {
                width: 200px;
                margin: 10px;
            }
        }
    }
</style>